document.addEventListener('DOMContentLoaded', function() {
    const body = document.body;
    const toggleNavCheckbox = document.getElementById('toggle-nav');
    const mobileNav = document.getElementById('mobile-nav');

    
    toggleNavCheckbox.addEventListener('change', function() {

        if (toggleNavCheckbox.checked) {

            body.style.overflow = 'hidden'
            mobileNav.classList.add('active');
            

        } else {

            body.style.overflow = 'scroll'
            mobileNav.classList.remove('active');
            
        }
    });


    var subMenus = document.querySelectorAll('.mobile-submenu-container .sub-menu');

    subMenus.forEach(function(subMenu) {
        var newLi = document.createElement('li');
        var newSpan = document.createElement('span');
        newSpan.classList.add('menu-back-arrow');
        newSpan.innerHTML = `
            <svg data-name="back arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 11.63">
                <path id="Path_161" data-name="Path 161" class="cls-1" d="M5.82,11.63l1.33-1.33-3.52-3.51h12.36v-1.94H3.64l3.52-3.51-1.33-1.33L0,5.81l5.82,5.82Z"/>
            </svg>
            Back`;
        newLi.classList.add('submenu-close');
        newLi.appendChild(newSpan); // Append the <span> element to the <li>
        subMenu.insertBefore(newLi, subMenu.firstElementChild); // Insert the new <li> as the first child of the submenu
    });
    


    var parentMenus = document.querySelectorAll('.menu-item-has-children');

    parentMenus.forEach(function(parentMenu) {

        parentMenu.addEventListener('click', function() {
            var submenu = this.querySelector('.mobile-submenu-container');
            if (submenu) {
                if (submenu.style.visibility === 'hidden' || submenu.style.display === '') {

                    submenu.classList.add('active');

                } else {

                    submenu.classList.remove('active');

                }
            }
        });

        var submenuClose = parentMenu.querySelector('.submenu-close');

        if (submenuClose) {
            submenuClose.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent parentMenu from being toggled
                var submenu = parentMenu.querySelector('.mobile-submenu-container');
                if (submenu) {
                    submenu.classList.remove('active');
                }
            });
        }

    });



    

});
